var map = {
	"./alfa_leasing.svg": 29358,
	"./aliexpress.svg": 47201,
	"./ar.svg": 30913,
	"./aviasales.svg": 14670,
	"./avito.svg": 47888,
	"./best_doctor.svg": 4507,
	"./cdek.svg": 37670,
	"./cian.svg": 44399,
	"./det_mir.svg": 98958,
	"./dodo.svg": 67818,
	"./ekoniva.svg": 19008,
	"./haier.svg": 4429,
	"./innopolis.svg": 36990,
	"./innova.svg": 57570,
	"./interfax.svg": 17822,
	"./komus.svg": 32672,
	"./krok.svg": 70359,
	"./lamoda.svg": 91134,
	"./lanit.svg": 38208,
	"./leroy_merlin.svg": 12567,
	"./megafon.svg": 61344,
	"./modulbank.svg": 3156,
	"./ostrovok.svg": 72764,
	"./pik.svg": 28012,
	"./rbk_money.svg": 39229,
	"./ru_center.svg": 93568,
	"./samokat.svg": 36868,
	"./segmento.svg": 51112,
	"./selectel.svg": 58442,
	"./simple.svg": 54718,
	"./skyeng.svg": 11479,
	"./splat.svg": 33530,
	"./sports_ru.svg": 82445,
	"./uchi_ru.svg": 57711,
	"./vk.svg": 12553,
	"./yandex_praktikum.svg": 6837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60720;